/**
 * Common validators - Shared primitive types used across the application
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Gender
// ============================================================================

export const genderValidator = v.union(
  v.literal('male'),
  v.literal('female'),
  v.literal('diverse')
);

export type Gender = Infer<typeof genderValidator>;

export const GENDERS = ['male', 'female', 'diverse'] as const;

// ============================================================================
// Theme
// ============================================================================

export const themeValidator = v.union(v.literal('light'), v.literal('dark'));

export type Theme = Infer<typeof themeValidator>;

export const THEMES = ['light', 'dark'] as const;

// ============================================================================
// Preferred Language
// ============================================================================

export const preferredLanguageValidator = v.union(v.literal('de'), v.literal('en'));

export type PreferredLanguage = Infer<typeof preferredLanguageValidator>;

export const PREFERRED_LANGUAGES = ['de', 'en'] as const;

// ============================================================================
// Login Provider
// ============================================================================

export const loginProviderValidator = v.union(
  v.literal('oauth_google'),
  v.literal('oauth_microsoft'),
  v.literal('oauth_apple'),
  v.literal('email_code')
);

export type LoginProvider = Infer<typeof loginProviderValidator>;

export const LOGIN_PROVIDERS = [
  'oauth_google',
  'oauth_microsoft',
  'oauth_apple',
  'email_code',
] as const;

// ============================================================================
// User Status (soft-delete)
// ============================================================================

export const userStatusValidator = v.union(
  v.literal('active'),
  v.literal('deleted'),
  v.literal('suspended')
);

export type UserStatus = Infer<typeof userStatusValidator>;

export const USER_STATUSES = ['active', 'deleted', 'suspended'] as const;
